'use client'

import { useMemo, useState } from 'react'
import GfArticleCards from '@/components/common/GfArticleCards'
import { getCategoryTitle, normalizeSlug } from '@/utils/categoryHelpers'

/**
 * Журнал на главной — «Gallery · Field»: bento-сетка статей с фильтром по
 * категориям (mono-чипы). Карточки рендерит общий GfArticleCards
 * (variant="bento", bucket) — единый «плиточный» вид статей по всему сайту.
 */
export default function HomeJournalGF({ posts = [], language = 'en' }) {
    const [active, setActive] = useState('all')

    // Чипы фильтра — все реально присутствующие категории (по любой категории
    // поста, как группируется пул главной), в порядке появления.
    const chips = useMemo(() => {
        const seen = new Map()
        for (const post of posts) {
            for (const c of post.categories || []) {
                const slug = normalizeSlug(c?.slug?.current)
                if (slug && !seen.has(slug)) seen.set(slug, getCategoryTitle(c, language))
            }
        }
        return Array.from(seen, ([slug, label]) => ({ slug, label }))
    }, [posts, language])

    const filtered = active === 'all'
        ? posts
        : posts.filter((post) => (post.categories || []).some((c) => normalizeSlug(c?.slug?.current) === active))

    if (posts.length === 0) return null

    const allLabel = language === 'ru' ? 'Все' : 'All'

    return (
        <>
            {chips.length > 1 && (
                <div className="gf-ops" role="group" aria-label={language === 'ru' ? 'Категории журнала' : 'Journal categories'}>
                    <button type="button" className={`all ${active === 'all' ? 'on' : ''}`} onClick={() => setActive('all')}>
                        {allLabel}
                    </button>
                    {chips.map((c) => (
                        <button key={c.slug} type="button" className={active === c.slug ? 'on' : ''} onClick={() => setActive(c.slug)}>
                            {c.label}
                        </button>
                    ))}
                </div>
            )}

            <GfArticleCards posts={filtered} lang={language} variant="bento" bucket showExcerpt={false} />
        </>
    )
}
